import ConfirmEmail from '~/pages/user/register/ConfirmEmail.vue'
import ResetPassword from '~/pages/user/ResetPassword.vue'
import SocialLoginProcessing from '~/pages/user/register/SocialLogin.vue'
import UserConfirmation from '~/pages/user/registration_confirmation.vue'

export default [
	{
		path: '/rest-auth/registration/account-confirm-email/:code',
		component: ConfirmEmail
	},
	{
		path: '/account-reset-password/:uid/:token',
		component: ResetPassword
	},
	{
		path: '/account/social-login/',
		name: 'social_login',
		component: SocialLoginProcessing
	},
	{
		path: '/user/confirmation',
		component: UserConfirmation,
		name: 'user_confirmation',
		meta: { requiresAuthNotActive: true }
	}
]
